import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
} from '@chakra-ui/core';

const iconButtonProps = {
  variant: 'ghost',
  variantColor: null,
  color: 'coral.900',
  height: 8,
  minW: 8,
  rounded: 'full',
  _hover: {
    '&:not([aria-disabled])': {
      color: 'white',
      backgroundColor: 'coral.900',
    },
  },
  _disabled: {
    color: 'semiDarkGray.600',
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  _focus: { shadow: 'none' },
};

const DocumentIconButton = ({ href, icon, label, disabledLabel, ml = 0 }) => {
  const isDisabled = !href;
  const tooltipLabel = isDisabled && disabledLabel ? disabledLabel : label;

  return (
    <Tooltip
      bg="semiDarkGray.900"
      label={tooltipLabel}
      placement="top"
      zIndex="tooltip"
      aria-label={tooltipLabel}
    >
      <Box as="span" d="inline-flex" ml={ml}>
        <IconButton
          as={href ? 'a' : 'button'}
          icon={icon}
          isDisabled={isDisabled}
          href={href}
          target={href ? '_blank' : undefined}
          aria-label={tooltipLabel}
          rel={href ? 'noopener noreferrer' : undefined}
          {...iconButtonProps}
          color={isDisabled ? 'semiDarkGray.600' : 'coral.900'}
        />
      </Box>
    </Tooltip>
  );
};

export const QuoteDocumentsAction = ({ lastQuoteUploaded, ergoReport }) => {
  const quoteDownloadLink = lastQuoteUploaded?.downloadLink;
  const ergoReportDownloadLink = ergoReport?.downloadLink;

  return (
    <Box as="span" d="inline-flex" alignItems="center" whiteSpace="nowrap">
      <DocumentIconButton
        href={quoteDownloadLink}
        icon="view"
        label="Voir le devis en ligne"
        disabledLabel="Aucun devis disponible"
      />
      <DocumentIconButton
        href={ergoReportDownloadLink}
        icon="report-file"
        label="Voir le compte-rendu ergo"
        disabledLabel="Aucun compte-rendu ergo disponible"
        ml={1}
      />
    </Box>
  );
};
